import { G } from '@mobily/ts-belt';
import { useViewEvent } from '@stitch-fix/event-reporter';
import { Text } from '@stitch-fix/mode-react';
import { SearchFragment } from '../../utils/hooks/getSearchResults';
import { ControlMenu } from '../ControlMenu';
import CorrectedQuery from '../CorrectedQuery';
import PaginationLinks from '../PaginationLinks';
import Results from './Results';
import { useSearchParams } from '../../utils/hooks/useSearchParams';
import { useGetClientInfoQuery } from '../../utils/hooks/getClientInfo';
interface ResultsSuccessProps {
  search: SearchFragment;
}

/**
 * The `<ResultsSuccess />` component handles rendering our results and
 * controls for updating a successful request
 */
const ResultsSuccess = ({
  search: {
    correctedQuery,
    filters,
    sortOptions,
    shopProductsByPage,
    queryId
  }
}: ResultsSuccessProps) => {
  const {
    queryParams
  } = useSearchParams();
  const {
    autoSearch
  } = queryParams;
  const {
    data: clientData
  } = useGetClientInfoQuery();
  const isAutoSearch = autoSearch;
  const {
    EventProvider,
    ref
  } = useViewEvent({
    schema: 'search_view',
    name: 'search_results',
    search_query_id: queryId
  });
  const shouldShowCorrectedQuery = G.isString(correctedQuery) && !isAutoSearch;
  const resultsExplanationText = clientData?.client?.isAuthenticatedClient === false ? 'Based on your search, we pulled these items that match their size, fit and style.' : 'Based on your search, we pulled these items that match your size, fit and style.';
  return <EventProvider>
      <div ref={ref}>
        {shouldShowCorrectedQuery ? <CorrectedQuery correction={correctedQuery} /> : <Text setting="body-small" align={{
        sm: 'left',
        md: 'center'
      }} mb={0.5}>
            {!isAutoSearch && resultsExplanationText}
          </Text>}

        <ControlMenu filters={filters} sortOptions={sortOptions} queryId={queryId} />

        <Results shopProducts={shopProductsByPage.edges.map(({
        node
      }) => node)} />

        <PaginationLinks pageCount={shopProductsByPage.pageCount} buttonGroupLabel="Pagination for search results" />
      </div>
    </EventProvider>;
};
export default ResultsSuccess;